import React, { useContext } from 'react';
import BannerAdUnit from '../AdUnit/Banner';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import {
  DEVPAGE_SIDEBAR_LOGGED_IN_REAL_ESTATE_ID,
  DEVPAGE_SIDEBAR_ANON_REAL_ESTATE_ID,
} from '../constants';

export interface Props {}

const DevpageSidebarPlacement: React.FC<Props> = () => {
  const { isLoggedIn } = useContext(SessionContext);

  // User
  if (isLoggedIn) {
    return (
      <BannerAdUnit
        width="308px"
        height="316px"
        realEstateId={DEVPAGE_SIDEBAR_LOGGED_IN_REAL_ESTATE_ID}
      />
    );
  }

  // Anon
  return (
    <BannerAdUnit width="308px" height="316px" realEstateId={DEVPAGE_SIDEBAR_ANON_REAL_ESTATE_ID} />
  );
};
DevpageSidebarPlacement.displayName = 'DevpageSidebarPlacement';

export default DevpageSidebarPlacement;
